import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/customers/money'; // Importing MoneyView component
import AgeView from 'views/customers/age'; // Importing AgeView component
import TagsView from 'views/customers/tags'; // Importing TagsView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component
import JugadoresActivosView from 'views/dashboard/jugadoresActivos'; // Importing JugadoresActivosView component
import JugadoresNuevosView from 'views/dashboard/jugadoresNuevos'; // Importing JugadoresNuevosView component
import DataView from 'views/dashboard/dataview'; // Importing DataView component
import { devConfig } from 'config/config'; // Importing development configuration
import { profile } from 'config/config'; // Importing profile configuration
import { countries } from 'config/config'; // Importing countries data
import { banners } from 'config/config'; // Importing banners data

/**
 * StatisticsView class extending JetView to create a dashboard view.
 */
export default class StatisticsView extends JetView {
    /**
     * Configures the layout of the StatisticsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var countrie = []; // Array to hold country data
        for (var i = 0; i < countries.length; i++) {
            countrie[i] = countries[i]; // Populating countrie array with countries
        }
        var toDateLocal; // Variable to hold the end date
        var fromDateLocal; // Variable to hold the start date
        var vthis = this; // Reference to the current instance
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            scroll: true, // Enable scrolling
            css: 'dashboard', // CSS class for styling
            id: 'a5', // Unique identifier for the view
            rows: [
                {
                    hidden: devConfig.getPermAction('dashboardInfo', 'Add'), // Hide if no permission
                },
                {
                    view: 'toolbar', // Toolbar for date filtering
                    paddingY: 2, // Vertical padding
                    css: 'dateFilter', // CSS class for styling
                    responsive: 'a5', // Responsive behavior
                    hidden: !devConfig.getPermAction('dashboardInfo', 'Add'), // Hide if no permission
                    cols: [
                        {
                            width: 140, // Width of the country select dropdown
                            css: 'contryFlasgList country', // CSS class for styling
                            id: 'countrySelect', // Unique identifier for the country select
                            view: 'richselect', // Rich select dropdown
                            name: 'CountrySelect', // Name attribute
                            value: countrie[0].id, // Default selected value
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country flags
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countrie, // Data for the dropdown
                                },
                            },
                        },
                        {
                            minWidth: 50, // Minimum width for the button
                            responsiveCell: false, // Disable responsive behavior
                            view: 'button', // Button for today's date
                            css: 'hover-botom', // CSS class for styling
                            select: true, // Enable selection
                            value: _('Hoy'), // Button label for today
                            id: 'day', // Unique identifier for the button
                            click: () => {
                                // Click event handler
                                fromDateLocal =
                                    webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    '00:00:00'; // Set start date to today at midnight
                                toDateLocal =
                                    new Date().getFullYear() +
                                    ':' +
                                    ('00' + (new Date().getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + new Date().getDate()).slice(-2) +
                                    ' ' +
                                    '23:59:59'; // Set end date to today at 23:59:59
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal, // Start date for filtering
                                    ToDateLocal: toDateLocal, // End date for filtering
                                    day: _('Hoy'), // Label for the date filter
                                    Country: $$('countrySelect').getValue(), // Selected country
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('dateDashboard:date', [
                                    dateFilter, // Trigger event with date filter
                                ]);
                            },
                        },
                        {
                            minWidth: 50, // Minimum width for the button
                            responsiveCell: false, // Disable responsive behavior
                            view: 'button', // Button for yesterday's date
                            css: 'hover-botom', // CSS class for styling
                            select: true, // Enable selection
                            value: _('Ayer'), // Button label for yesterday
                            click: () => {
                                // Click event handler
                                fromDateLocal =
                                    webix.Date.add(new Date(), -1, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -1, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    '00:00:00'; // Set start date to yesterday at midnight
                                toDateLocal =
                                    webix.Date.add(new Date(), -1, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -1, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    '23:59:59'; // Set end date to yesterday at 23:59:59
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal, // Start date for filtering
                                    ToDateLocal: toDateLocal, // End date for filtering
                                    day: _('Ayer'), // Label for the date filter
                                    Country: $$('countrySelect').getValue(), // Selected country
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('dateDashboard:date', [
                                    dateFilter, // Trigger event with date filter
                                ]);
                            },
                        },
                        {
                            minWidth: 50, // Minimum width for the button
                            responsiveCell: false, // Disable responsive behavior
                            view: 'button', // Button for the last 30 days
                            value: _('Ultimos 30 días'), // Button label for last 30 days
                            click: () => {
                                // Click event handler
                                fromDateLocal =
                                    webix.Date.add(new Date(), -29, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -29, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -29, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    '00:00:00'; // Set start date to 30 days ago at midnight
                                toDateLocal =
                                    webix.Date.add(new Date(), -0, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    '23:59:59'; // Set end date to today at 23:59:59
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal, // Start date for filtering
                                    ToDateLocal: toDateLocal, // End date for filtering
                                    day: _('Ultimos 30 días'), // Label for the date filter
                                    Country: $$('countrySelect').getValue(), // Selected country
                                };
                                console.log(dateFilter); // Log the date filter
                                this.app.callEvent('dateDashboard:date', [
                                    dateFilter, // Trigger event with date filter
                                ]);
                            },
                        },
                        {
                            minWidth: 200, // Minimum width for the form
                            view: 'form', // Form for date range selection
                            class: 'date-dashboard', // CSS class for styling
                            id: 'myform', // Unique identifier for the form
                            type: 'clean', // Clean form type
                            elements: [
                                {
                                    view: 'text', // Text input for date range
                                    name: 'regDateRange', // Name attribute
                                    id: 'regDateRange', // Unique identifier for the input
                                    css: 'reportrange', // CSS class for styling
                                    readonly: true, // Make the input read-only
                                    placeholder: _('Click para seleccionar '), // Placeholder text
                                },
                            ],
                            padding: 0, // No padding
                        },
                    ],
                },
                {
                    height: 10, // Spacer with height
                },
                {
                    hidden: devConfig.getPermAction('dashboardInfo', 'Add'), // Hide if no permission
                },
                {
                    type: 'wide', // Wide layout type
                    id: 'preloader', // Unique identifier for the preloader
                    hidden: !devConfig.getPermAction('dashboardInfo', 'Add'), // Hide if no permission
                    rows: [
                        {
                            gravity: 2, // Gravity for layout distribution
                            type: 'wide', // Wide layout type
                            cols: [
                                {
                                    type: 'wide', // Wide layout type
                                    minWidth: 250, // Minimum width for the column
                                    rows: [DataView], // DataView component
                                },
                            ],
                        },
                        {
                            type: 'wide', // Wide layout type
                            cols: [
                                JugadoresActivosView, // JugadoresActivosView component
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the StatisticsView.
     */
    init() {
        var initThis = this; // Reference to the current instance
        var ban = false; // Flag to track focus state
        $$('regDateRange').attachEvent('onFocus', function (prev_view) {
            ban = true; // Set flag when input is focused
        });
        $('.reportrange input').change(function () {
            // Change event for date range input
            const dateRange = $('.reportrange input').val().split(' - '); // Split input value into start and end dates
            const dateFilter = {
                FromDateLocal: dateRange[0].replace(/-/g, ':') + ' 00:00:00', // Start date for filtering
                ToDateLocal: dateRange[1].replace(/-/g, ':') + ' 23:59:59', // End date for filtering
                day: 'Del: ' + dateRange[0].replace(/-/g, ':') + ' Hasta: ' + dateRange[1].replace(/-/g, ':'), // Label for the date filter
                Country: $$('countrySelect').getValue(), // Selected country
            };
            if (ban) {
                initThis.app.callEvent('dateDashboard:date', [dateFilter]); // Trigger event with date filter if input was focused
            }
        });
        webix.ready(function () {
            // Webix ready event
            setTimeout(() => {
                // Delay execution
                if (banners.length > 0) {
                    // Check if there are banners
                    banners.forEach((item) => {
                        // Iterate over banners
                        item.css = 'image'; // Set CSS class for banner
                        item.template = img; // Set template for banner
                        item.data = { src: item.url, redirect: item.redirect }; // Set data for banner
                    });
                }
                function img(obj) {
                    // Function to generate image HTML for banners
                    var image = '';
                    if (screen.width < 500) {
                        // Check screen width for responsive design
                        image =
                            '<a href="' +
                            obj.redirect +
                            '" target="_blank"><img src="' +
                            obj.src +
                            '" style="' +
                            'max-width:' +
                            $$('a5').$width +
                            'px;' +
                            '" class="content"></a>'; // Image for small screens
                    } else {
                        image =
                            '<a href="' +
                            obj.redirect +
                            '" target="_blank"><img src="' +
                            obj.src +
                            '" class="content"></a>'; // Image for larger screens
                    }
                    return image; // Return generated image HTML
                }
                var carousel = {
                    view: 'carousel', // Carousel view for displaying banners
                    hidden: banners.length <= 0, // Hide if no banners
                    id: 'carousel', // Unique identifier for the carousel
                    height: screen.width > 500 ? 300 : 100, // Set height based on screen width
                    width: $$('a5').$width, // Set width based on parent view
                    cols: banners, // Set banners as columns in the carousel
                };
                $$('a5').addView(carousel, 0); // Add carousel to the view
                var length = $$('carousel').getChildViews()[0].getChildViews().length; // Get the number of child views in the carousel
                setInterval(function () {
                    // Set interval for automatic carousel rotation
                    if ($$('carousel').getActiveIndex() < length - 1)
                        $$('carousel').showNext(); // Show next banner
                    else $$('carousel').setActiveIndex(0); // Reset to first banner
                }, 5000); // Rotate every 5 seconds
            }, 1000); // Delay execution by 1 second
        });
    }
}

// FILE DOCUMENTED
